module.exports = __webpack_public_path__ + "media/images/articles/interview/img03-56beff4ea16a2a66973e92a817719c46.png";